import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteReportUploadAction,
  getAppoinmentAction,
  getAppoinmentReportUploadAction,
  getAppointmentQueueFilterCountsAction,
  reportUploadFileAction,
  updateAppoinmentStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import moment from "moment";
import { getDispatch } from "../../../Utils/helper";
import { IS_SHOW_POPUP } from "../../../Utils/types";

export const UploadReportPopup = ({
  isUploadReportPopup,
  setIsUploadReportPopup,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();
  const [fileType,setFileType] = useState(false)
  const getAppoinmentUploadReport = useSelector(
    (state) => state?.AppoinmentReducer?.getAppoinmentUploadReport
  );

  useEffect(() => {
    dispatch(
      getAppoinmentReportUploadAction(
        isUploadReportPopup?.cardDetails?.valueType,
        isUploadReportPopup?.cardDetails?.appointmentId
      )
    );
  }, []);

  useEffect(() => {
    setFileType(fileType)
  }, [fileType]);

  const handleFileChange = async (e) => {
    const image = e.target.files[0]
    if (image.name.match(/\.(jpg|jpeg|png|pdf|PDF|JPG|JPEG|PNG)$/)) {
      setFileType(false)
      const formData = new FormData();
      Object.values(e.target.files)?.map((ele) => {
        return formData.append("Attachments", ele);
      });
      formData.append(
        "AppointmentId",
        isUploadReportPopup?.cardDetails?.appointmentId
      );
      formData.append("FilePath", null);
      formData.append("ViewPath", null);
      formData.append("FileName", null);
      formData.append("FileExtesion", null);
      formData.append("FileNameWithoutExtesion", null);
      formData.append("ImageUrl", null);
      formData.append("ReportPath", null);
      formData.append("DCConfirmationFlag", "U");
      formData.append("ValueType", isUploadReportPopup?.cardDetails?.valueType);
      await dispatch(
        reportUploadFileAction(
          formData,
          isUploadReportPopup?.cardDetails?.valueType,
          dispatch
        )
      );
      await dispatch(
        getAppoinmentReportUploadAction(
          isUploadReportPopup?.cardDetails?.valueType,
          isUploadReportPopup?.cardDetails?.appointmentId
        )
      );
    } else {
      setFileType(true)
    }
   
  };

  const handleClose = () => {
    setIsUploadReportPopup(null);
    getDispatch(IS_SHOW_POPUP, false, dispatch);
    setFileType(false)
  };

  return (
    <>
      <div className="d-flex justify-content-between  border-bottom modalHeader">
        <h4 className="font-bold text-black">Uploaded Reports </h4>
        <button
          type="button"
          className="btn-close history-close"
          onClick={handleClose}
        ></button>
      </div>
      <div className="modal-body">
        <div className="table-responsive __custom__properties">
          {isUploadReportPopup?.isUploadReport && (
            <label>
              <input
                type="file"
                id="imageUpload"
                style={{ width: "2px" }}
                onChange={(e) => handleFileChange(e)}
                multiple
              />
              <span
                className="d-flex align-items-center gap-10"
                style={{ cursor: "pointer" }}
              >
                <p className="upload-file-p" style={{ color: "#5157a0" }}>
                  Select a file to upload
                </p>
                <i className="fa fa-upload" style={{ color: "#5157a0" }}></i>
              </span>
              {fileType === true &&  <p style={{ color: "red",fontSize:"12px" }}>Please select jpg, jpeg, png and pdf file.</p>}
              <p></p>
            </label>
          )}
          <table className="table mt-3">
            <thead>
              <tr className="table-upload-tr">
                <th scope="col">Report Name</th>
                <th scope="col" className="text-center">
                  View
                </th>
                {isUploadReportPopup?.isUploadReport && (
                  <th scope="col" className="text-center">
                    Remove
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {getAppoinmentUploadReport?.results?.length ? (
                getAppoinmentUploadReport?.results?.map((ele, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <span
                          className="status-style"
                          style={{
                            textTransform: "capitalize",
                            fontWeight: "500",
                          }}
                        >
                          {ele?.fileName}
                        </span>
                      </td>
                      <td className="text-center">
                        <a
                          href={ele?.filePath}
                          style={{ color: "black" }}
                          target="blank"
                        >
                          <i className="fa fa-eye"></i>
                        </a>
                      </td>
                      {isUploadReportPopup?.isUploadReport && ele?.isAppType===true && (
                        <td className="text-center">
                          <img
                            type="button"
                            src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              await dispatch(
                                deleteReportUploadAction({
                                  docId: ele?.docId,
                                  valueType:
                                    isUploadReportPopup?.cardDetails?.valueType,
                                  appointmnetId:
                                    isUploadReportPopup?.cardDetails
                                      ?.appointmentId,
                                })
                              );
                              await dispatch(
                                getAppoinmentReportUploadAction(
                                  isUploadReportPopup?.cardDetails?.valueType,
                                  isUploadReportPopup?.cardDetails
                                    ?.appointmentId
                                )
                              );
                            }}
                            alt=""
                          />
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <p className="no-record-p">No Record Found</p>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isUploadReportPopup?.isUploadReport && (
        <div
          className="modal-footer"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            gap: "20px",
          }}
        >
          <div>
            {getAppoinmentUploadReport?.message && (
              <>
                <b>Remarks:</b> {getAppoinmentUploadReport?.message}
              </>
            )}
          </div>
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-close-upload"
              onClick={handleClose}
            >
              Close
            </button>
             <button
              type="button"
              className="btn btn-upload-upload"
              onClick={async () => {
                await dispatch(
                  updateAppoinmentStatusAction({
                    valueType: isUploadReportPopup?.cardDetails?.valueType,
                    AppointmentId:
                      isUploadReportPopup?.cardDetails?.appointmentId,
                    DCConfirmationFlag: "U",
                    validate: false,
                    AppointmentDate: moment(
                      isUploadReportPopup?.cardDetails?.appointmentDateTime
                    ).format("YYYY-MM-DD hh:mm A"),
                    AppointmentStatusId:
                      isUploadReportPopup?.cardDetails?.appointmentstatusid,
                  })
                );
                setTimeout(async()=>{
                  await dispatch(
                    getAppoinmentAction({ ...searchFilter, ...apiParams })
                  );
                  await dispatch(
                    getAppointmentQueueFilterCountsAction({ ...searchFilter, ...apiParams })
                  );
                },1000)
               
                await handleClose();
              }}
              disabled={getAppoinmentUploadReport?.results?.length === 0}
              style={{ width: "90px", marginLeft: "10px" }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
};
